import { useKeycloak } from '@react-keycloak/web';
import React from 'react';

const Logout = () => {
	const keycloakInstance = useKeycloak();

	const onLogOutButton = () => {
		keycloakInstance.keycloak.logout();
	};

	return (
		<>
			<button className="button is-link" onClick={onLogOutButton}>
				<i className="icon fz-logout" />
			</button>
		</>
	);
};

export default Logout;
